import { render, staticRenderFns } from "./MDDropdown.vue?vue&type=template&id=438a1bd1"
import script from "./MDDropdown.vue?vue&type=script&lang=js"
export * from "./MDDropdown.vue?vue&type=script&lang=js"
import style0 from "./MDDropdown.vue?vue&type=style&index=0&id=438a1bd1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports